import useQueryState from "Components/Hooks/UseQueryState";
import { useProfile } from "Components/Hooks/UserHooks";
import profileBg from "assets/images/wfp-somalia-cover.jpg";
import { getYearDateRange } from "common/lib/dateUtils";
import { getIndividuals } from "common/services/individuals.service";
import { getPayments } from "common/services/payments.service";
import React, { useEffect } from "react";
import { Col, Row } from "reactstrap";

const currentYear = new Date().getFullYear().toString();
const generateYearOptions = () => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 5 }, (_, index) => {
    const year = currentYear - index;
    return { value: year.toString(), label: year.toString() };
  });
};
const Header = () => {
  const { userProfile } = useProfile();

  const [selectedYear, setSelectedYear] = useQueryState("year", currentYear);

  const [totalContracts, setTotalContracts] = React.useState(0);
  const [totalIndividuals, setTotalIndividuals] = React.useState(0);

  const { firstDay, lastDay } = getYearDateRange(Number(selectedYear));

  useEffect(() => {
    const fetchData = async () => {
      const response: any = await getPayments({
        filters: {
          agency: {
            id: {
              $eq: userProfile?.agency?.id,
            },
          },
          $or: [
            {
              startDate: {
                $between: [firstDay, lastDay],
              },
            },
            {
              endDate: {
                $between: [firstDay, lastDay],
              },
            },
          ],
        },
      });
      setTotalContracts(response?.meta?.pagination?.total);
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  useEffect(() => {
    const fetchData = async () => {
      const response: any = await getIndividuals({
        filters: {
          payments: {
            $and: [
              {
                agency: {
                  id: {
                    $eq: userProfile?.agency?.id,
                  },
                },
              },
              {
                $or: [
                  {
                    startDate: {
                      $between: [firstDay, lastDay],
                    },
                  },
                  {
                    endDate: {
                      $between: [firstDay, lastDay],
                    },
                  },
                ],
              },
            ],
          },
        },
      });
      setTotalIndividuals(response?.meta?.pagination?.total);
    };
    fetchData();
  }, [firstDay, lastDay, userProfile?.agency?.id]);

  const options = React.useMemo(() => generateYearOptions(), []);

  return (
    <>
      <div className="profile-foreground position-relative rounded">
        <div className="profile-wid-bg rounded">
          <img src={profileBg} alt="" className="profile-wid-img rounded" />
        </div>
      </div>
      <div className="pt-4 mb-4 mb-lg-3 pb-lg-4 px-4">
        <Row className="g-4">
          {/* <div className="col-auto">
                <div className="avatar-lg">
                  <img
                    src={avatar1}
                    alt="user-img"
                    className="img-thumbnail rounded-circle"
                  />
                </div>
              </div> */}

          <Col>
            <div className="p-2">
              <h3 className="text-white mb-1">
                {userProfile?.agency?.name || ""}
              </h3>
              <p className="text-white text-opacity-75">
                {userProfile?.agency?.category?.name || ""}
              </p>
              <div className="hstack text-white text-opacity-75 gap-1">
                <div className="me-2">
                  <i className="ri-exchange-dollar-line me-1 text-white text-opacity-75 fs-16  "></i>
                  {totalContracts}{" "}
                  {totalContracts === 1 ? "Contract" : "Contracts"}
                </div>
                <div className="me-2">
                  <i className="ri-account-circle-line me-1 text-white text-opacity-75 fs-16 "></i>
                  {totalIndividuals}{" "}
                  {totalIndividuals === 1 ? "Position" : "Positions"} Funded
                </div>
                {/* <div>
                  <i className="ri-bank-line me-1 text-white text-opacity-75 fs-16 "></i>
                  {totalMDAs} MDAs/Partners
                </div> */}
              </div>
            </div>
          </Col>

          <Col xs={12} className="col-lg-auto order-last order-lg-0">
            <Row className="text text-white-50 text-center">
              <Col lg={12} xs={12}>
                {/* <div className="p-2">
                  <h4 className="text-white mb-1">{totalMDAs}</h4>
                  <p className="fs-14 mb-0">MDAs/Partners</p>
                </div> */}
                <div className="p-2">
                  <div className="mb-5" aria-hidden="true" />
                  <p className="fs-14 mb-0"></p>
                </div>
                {/* @ts-ignore */}
                <div className="">
                  <select
                    className="form-control "
                    data-choices
                    data-choices-search-false
                    name="choices-single-default2"
                    id="choices-single-default2"
                    onChange={(e) => {
                      setSelectedYear(e.target.value);
                    }}
                  >
                    {/* <option value="">Select Year</option> */}
                    {options.map((option: any) => (
                      <option key={option.value} value={option.value}>
                        Year of analysis - {option.label}
                      </option>
                    ))}
                  </select>
                </div>
              </Col>
              {/* <Col lg={6} xs={4}>
                    <div className="p-2">
                      <h4 className="text-white mb-1">1.3K</h4>
                      <p className="fs-14 mb-0">Following</p>
                    </div>
                  </Col> */}
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Header;
